<template>
  <div>
    <button @click="axiosGet()">Axios Get</button>
    <button @click="axiosPost()">Axios Post</button>
    <button @click="axiosPUT()">Axios PUT</button>
    <sampleComponent :testMsg="sampleData"></sampleComponent>
  </div>
</template>
<script>
import sampleComponent from "@/components/sample_component.vue";

//validation 관련된 함수
// import {EmailFormatCheck,IDFormatCheck,PWFormatCheck} from "@/utils/validation.js";

//url 파라미터파싱, 날짜 파싱 관련된 함수
// import {GetUrlParams,GetFormatToday} from "@/utils/common.js";

export default {
  name: "sample",
  data: () => ({
    sampleData: "abc",
    isAxiosRun: false,
  }),
  components: {
    sampleComponent,
  },
  mounted() {},
  methods: {
    axiosPost() {
      //post sample code
      if (this.isAxiosRun == true) {
        return false;
      }
      this.isAxiosRun = true;

      const params = {
        sample: "post",
      };
      this.axios
        .post("/api/v1/post", params)
        .then((res) => {
          //axios 통신 성공시
          this.isAxiosRun = false;
          console.log(res);
        })
        .catch((err) => {
          //axios error 일시(Timeout)
          this.isAxiosRun = false;
          console.log(err);
        });
    },
    axiosGet() {
      //get sample code
      const params = {
        sample: "get",
      };
      this.axios
        .get("/api/v1/get", params)
        .then((res) => {
          //axios 통신 성공시
          console.log(res);
        })
        .catch((err) => {
          //axios error 일시(Timeout)
          console.log(err);
        });
    },
    axiosPUT() {
      const params = {
        sample: "put",
      };
      this.axios
        .put("/api/v1/PUT", params)
        .then((res) => {
          //axios 통신 성공시
          console.log(res);
        })
        .catch((err) => {
          //axios error 일시(Timeout)
          console.log(err);
        });
    },
  },
};
</script>
